// tracker.ts

import {
  AiChatErrorProperties,
  AiChatPerformanceProperties,
  AiChatSideEffectProperties,
  AiChatWarningProperties,
  ProjectLaunchErrorProperties,
  EventType,
  TerminalErrorProperties,
} from "./types";
import posthog from "posthog-js";
import { toast } from "sonner";

interface EventPropertiesMap {
  AI_CHAT_SIDE_EFFECT: AiChatSideEffectProperties;
  AI_CHAT_ERROR: AiChatErrorProperties;
  AI_CHAT_WARNING: AiChatWarningProperties;
  AI_CHAT_PERFORMANCE: AiChatPerformanceProperties;
  PROJECT_LAUNCH_ERROR: ProjectLaunchErrorProperties;
  TERMINAL_WRITE_ERROR: TerminalErrorProperties;
}

type EventProperties<T extends EventType> =
  | (T extends keyof EventPropertiesMap
      ? EventPropertiesMap[T]
      : Record<string, any>)
  | undefined;

export function track<T extends EventType>(
  eventType: T,
  properties: EventProperties<T> = {} as EventProperties<T>
): void {
  if (import.meta.env.VITE_ENVIRONMENT !== "DEV") {
    posthog.capture(eventType, properties);
  } else {
    console.log("posthog event", eventType, properties);
  }
}

// Create a wrapper function
let originalToastError = toast.error;
function customToastError(message, options) {
  // Add your additional functionality here
  track("TOAST_ERROR", { message }); // Example: log the error to an external service

  // Call the original toast.error function
  return originalToastError(message, options);
}

toast.error = customToastError;
